import {
	Component,
	ComponentInterface,
	Element,
	h,
	Host,
	Listen,
	Prop,
} from '@stencil/core';
import { Breakpoint, getCurrentBreakpoint } from '../_helpers/breakpoints';

@Component({
	tag: 'ds-standard-banner-classic',
})
export class StandardBannerClassic implements ComponentInterface {
	@Element() el: HTMLDsStandardBannerClassicElement;
	currentBreakPoint: Breakpoint;

	@Prop() smallImageAlt: string;
	@Prop() imageAlt: string;

	@Listen('resize', { target: 'window' })
	windowResizeHandler() {
		this.setAltTextForImage();
	}

	componentWillLoad(): void {
		this.setAltTextForImage();
	}

	setAltTextForImage(): void {
		this.currentBreakPoint = getCurrentBreakpoint();
		const imageElement: HTMLElement = this.el.querySelector('img');

		if (imageElement) {
			switch (this.currentBreakPoint) {
				case Breakpoint.XS:
				case Breakpoint.SM:
					this.smallImageAlt
						? imageElement.setAttribute('alt', this.smallImageAlt)
						: imageElement.setAttribute('alt', this.imageAlt);
					break;
				case Breakpoint.MD:
				case Breakpoint.LG:
				case Breakpoint.XL:
					imageElement.setAttribute('alt', this.imageAlt);
					break;
			}
		}
	}

	render() {
		return (
			<Host>
				<slot></slot>
			</Host>
		);
	}
}
